const DEFAULT_PRODUCT_IMAGE = '/img/fertilizer.png'

const resolveImageUrl = (url) => {
  if (!url || typeof url !== 'string') return null
  if (url.startsWith('http://') || url.startsWith('https://')) return url

  const base = (process.env.REACT_APP_BASE_URL || '').replace(/\/api\/v1\/?$/, '')
  return `${base}${url.startsWith('/') ? '' : '/'}${url}`
}

const pickImageFromList = (images = []) => {
  if (!Array.isArray(images) || images.length === 0) return null
  const primary = images.find((img) => img?.is_primary) || images[0]
  return primary?.image || primary?.url || null
}

export const getOrderItemImage = (orderItem, fallback = DEFAULT_PRODUCT_IMAGE) => {
  const images =
    orderItem?.product?.product_images ||
    orderItem?.product_images ||
    orderItem?.product?.images ||
    orderItem?.images ||
    []

  const url = pickImageFromList(images)
  return resolveImageUrl(url) || fallback
}

export const getOrderImage = (order, fallback = DEFAULT_PRODUCT_IMAGE) => {
  const firstItem = order?.items?.[0]
  return firstItem ? getOrderItemImage(firstItem, fallback) : fallback
}
